import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

import { deleteClient } from '../../../redux/slices/admin/coachesSlice'; 

const CoachesTable = ({ handlePageChange, handleDelete, openEditModal }) => {
  const dispatch = useDispatch();
  const { users, currentPage, totalPages } = useSelector((state) => state.admin_coaches);
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

 const toggleDropdown = (id, event) => {
    if (openDropdown === id) {
      setOpenDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setOpenDropdown(id);
    }
  };

   const handleClickOutside = (event) => {
    const isDropdownToggle = event.target.closest('.dropdown-toggle');
    const isDropdownMenu = event.target.closest('.dropdown-menu');
    if (!isDropdownToggle && !isDropdownMenu) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onHandleDelete = (user, id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this coach?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteClient({ user, id, currentPage }))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

   const handleScroll = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Clients Assigned</th>
            <th>Last Sign-In</th>
            <th className="noprint">Manage</th>
          </tr>
        </thead>
        <tbody>
          {users && users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>
                <td>
                  <div className="text-start">{user.first_name} {user.last_name}
                  <div><b>Email</b>: {user.email}</div></div>
                </td>
                <td>{user.super_admin == '1' ? 'Super Admin' : 'Coach'}</td>  
                <td>{user.users_assigned_count}</td>              
                <td>{user.last_signin}</td>
                <td className="noprint">
                  <div className="text-center position-relative" ref={dropdownRef}>
                    <button 
                      type="button" 
                      className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots" 
                      aria-expanded="false" 
                      onClick={(e) => toggleDropdown(user.id, e)}
                    >
                      <img src={optionsIcon} alt="Options" />
                    </button>
                    {openDropdown === user.id && (
                     <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >   
                        <li>
                          <a
                          className="dropdown-item"
                          onClick={() => openEditModal(user)}
                        >
                          <img src={editIcon} alt="Edit" /> Edit
                        </a>
                        </li>

                        {localStorage.getItem('486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese') == '1' && (
                          <li>
                            <a className="dropdown-item" onClick={() => onHandleDelete(user, user.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                        )}

                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">No coaches found.</td>
            </tr>
          )}
        </tbody>
      </table>
      </div>

      <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default CoachesTable;